import React, { Component, PropTypes } from 'react';

import Case from '../../components/timelinecase/timelineCase';
import Hero from '../../components/timelinehero/timelineHero';
import HeroMonth from '../../components/timelinehero/timelineHeroMonth';
import HeroYear from '../../components/timelinehero/timelineHeroYear';
import Editorial from '../../components/timelineeditorial/timelineEditorial';
import EditorialImage from '../../components/timelineeditorial/timelineEditorialImage';
import EditorialArticle from '../../components/timelineeditorial/timelineEditorialArticle';
import Jobs from '../../components/timelinejobs/timelineJobs';
import PageSplitter from './pageSplitter';
import forEach from 'lodash/forEach';

import css from './display.scss';

export default class TimelineDisplay extends Component {
	static propTypes = {
		items: PropTypes.array.isRequired,
		browser: PropTypes.object.isRequired,
		updatePushState: PropTypes.func,
	};

	static defaultProps = {
		items: [],
		updatePushState: () => {},
	};

	constructor(props) {
		super();

		this.containerHeight = 0;
		this.state = this.state || {};
	}

	componentWillMount() {
	}

	componentDidMount() {}

	shouldComponentUpdate(nextProps, nextState) {
		// this.scrollY = window.scrollY;

		// update on init
		if ((!this.props.items.length && nextProps.items.length)) {
			return true;
		}

		// browser changed
		if (this.props.browser && this.props.browser.window && nextProps.browser.window.width !== this.props.browser.window.width) {
			return true;
		}

		// update on change
		if (this.props.items.length !== nextProps.items.length) {
			return true;
		}

		for (var i = 0; i < nextProps.items.length; i++) {
			if (
				typeof this.props.items[i] === 'undefined' ||
				this.props.items[i].uid !== nextProps.items[i].uid
			) {
				return true;
			}
		}

		// stay the same
		return false;
	}

	render() {
		this.elementCount = 0;
		this.pageCount = 0;
		this.uids = [];

		return (
			<ul className='timeline' ref='container'>
				{this.props.items.map((item, i) => item && this.renderItem(item, i))}
				<li className='clearfix'></li>
			</ul>
		);
	}

	renderItem(item, i) {
		if ((i < this.props.skip || item.hidden) && item.type !== 'page-indicator') {
			return null;
		}

		let same = '';

		if (item.sortDate == this.sameTest && this.props.browser.window.width < 720 && item.hero != 1) {
			same = 'same';
		} else if (item.sortDate == this.sameTest && item.hero != 1) {
			same = 'same';
			this.elementCount++;
		} else {
			this.elementCount++;
		}

		let before = (this.elementCount % 2) ? 'even' : 'odd';

		if (item.hero == 1) {
			this.elementCount = 0;
			this.sameTest = 0;
		}

		let className = (this.elementCount % 2) ? 'odd' : 'even';
		let uid = item.uid;

		this.sameTest = item.sortDate;

		switch (item.type) {
			case 'page-indicator':
				uid = item.uid || ('page' + i);
				this.elementCount--;
				this.pageCount++;

				forEach(this.uids, function(single){
					if (uid == single) {
						uid = uid + 1;
						console.log('I WORK');
					}
				});

				this.uids.push(uid);

				return (
					<PageSplitter key={uid} ref={'splitter' + (this.pageCount + this.props.startPage)} hasPushState={this.props.hasPushState} lastSplitter={(page) => this.refs['splitter' + page]} page={this.pageCount - 1 + this.props.startPage} updatePushState={this.props.updatePushState} browser={this.props.browser} />
				);
			case 'awards':
				uid = item.uid || ('case' + item.item.id);

				forEach(this.uids, function(single){
					if (uid == single) {
						uid = uid + 1;
					}
				});

				this.uids.push(uid);

				if (item.hero == 1) {
					if (item.month == 1) {
						return (
							<HeroMonth {...item.item} before={before} awardId={item.awardId} isFirstHero={(i === 0)} sortDate={item.sortDate} browser={this.props.browser} key={uid} />
						);
					} else if (item.year == 1) {
						return (
							<HeroYear {...item.item} before={before} awardId={item.awardId} isFirstHero={(i === 0)} sortDate={item.sortDate} browser={this.props.browser} key={uid} />
						);
					}  else {
						return (
							<Hero {...item.item} before={before} awardId={item.awardId} isFirstHero={(i === 0)} sortDate={item.sortDate} browser={this.props.browser} key={uid} />
						);
					}
				} else {
					return (
						<Case {...item.item} same={same} awardId={item.awardId} sortDate={item.sortDate} browser={this.props.browser} className={className} key={uid} />
					);
				}

				break;
			case 'editorials':
				uid = item.uid || ('editorial' + item.item.id);

				forEach(this.uids, function(single) {
					if (uid == single) {
						uid = uid + 1;
						console.log('I WORK');
					}
				});

				this.uids.push(uid);

				switch (item.item.timelineType) {
					case 'IMAGE':
						return (
								<EditorialImage {...item.item} same={same} sortDate={item.sortDate} browser={this.props.browser} className={className} key={uid} />
						);
						break;
					case 'HEADLINE':
						return (
								<EditorialArticle {...item.item} same={same} sortDate={item.sortDate} browser={this.props.browser} className={className} key={uid} />
						);
						break;
					case 'EXCERPT':
						return (
								<Editorial {...item.item} same={same} sortDate={item.sortDate} browser={this.props.browser} className={className} key={uid} />
						);
						break;
					default:
						return (
								<EditorialImage {...item.item} same={same} sortDate={item.sortDate} browser={this.props.browser} className={className} key={uid} />
						);
				}
				break;
			case 'jobs':
				uid = item.uid || ('jobs' + item.id);

				forEach(this.uids, function(single){
					if (uid == single) {
						uid = uid + 1;
						console.log('I WORK');
					}
				});

				this.uids.push(uid);

				return (
						<Jobs item={item} same={same} sortDate={item.sortDate} browser={this.props.browser} className={className} key={uid} />
				);
			default:
				console.log('FAULTY ITEM::');
				console.log(item);
				return null;
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timeline/display.js
 **/